<div class="gold-sync-container">
  <ul class="tab tab-pills gs-inner-tabs">
    <li (click)="setTab(0)" (mouseenter)="dashboardTabHover = true" (mouseleave)="dashboardTabHover = false">
      <a [ngClass]="{ activeTab: tabIndex === 0, inactiveTab: tabIndex !== 0 && dashboardTabHover }">Sync Dashboard</a>
    </li>
    <li (click)="setTab(1)" (mouseenter)="logTabHover = true" (mouseleave)="logTabHover = false">
      <a [ngClass]="{ activeTab: tabIndex === 1, inactiveTab: tabIndex !== 1 && logTabHover }">Log History</a>
    </li>
  </ul>
  <hr class="gs-inner-tabs-divider" />

  <!-- Tab 0: Sync Dashboard -->
  @if (tabIndex === 0) {
<div class="container-fluid gold-sync">
    <div class="row gs-header-row" [class.shake]="mulSelectDropDownDoShake">
      <div class="gs-header-item">
        <span class="gs-label">Sync Type*</span>
        <select class="form-control gs-filter-select" [(ngModel)]="selectedGroupType" (ngModelChange)="groupTypeChanged($event)">
          @for (g of groupTypes; track $index) {
<option [ngValue]="g">{{ g.grp_type }}</option>
}
        </select>
      </div>
      @if (enableTaxYearSelection) {
<div class="gs-header-item">
        <span class="gs-label">Tax Year*</span>
        <select class="form-control gs-filter-select" [ngModel]="selectedTY" (ngModelChange)="taxYearChanged($event)">
          <option value="">Select</option>
          @for (x of openTaxYears; track $index) {
<option [value]="x.tax_year">{{ x.tax_year }}</option>
}
        </select>
      </div>
}
      @if (enableScenarioSelection) {
<div class="gs-header-item">
        <span class="gs-label">Scenario*</span>
        <ap-dropdown
          class="scenario-multiselect"
          [list]="scenarioDropdownList"
          [(ngModel)]="selectedScenario"
          [selectType]="'multiple'"
          [enableNgContent]="false"
          [optionName]="'scenario_desc'"
          [optionValue]="'scenario'"
          [title]="'Select open scenario'"
          [inputAriaLabel]="'Scenario'"
          [hideTitleOnInput]="true"
          [showSearchbox]="true"
          [showSelectAll]="true"
          [clearSearchKeyword]="true"
          (onFilterResult)="onScenarioFilterResult($event)"
        ></ap-dropdown>
      </div>
}
    </div>

    <div class="searchRow">
      <div class="toolbar-left">
        <i
          class="fa fa-refresh gt-refresh toolbar-icon"
          ap-tooltip [appendAfterTarget]="true" tooltipContent="Refresh data"
          direction="top"
          (click)="refresh()"
        ></i>
        <span class="btn btn-success btn-xs action-btn" (click)="openCreateNewModal()">New Job</span>
      </div>
      @if (goldSyncData.length > 0) {
<div class="toolbar-right">
        <div class="searchDiv">
          <div class="searchBlock">
            <input
              type="text"
              class="contentSearch"
              [(ngModel)]="dashboardSearchTerm"
              (ngModelChange)="dashboardCurrentPage = 1"
              placeholder="Search"
            />
          </div>
          <i class="fa fa-search searchIcons"></i>
        </div>
      </div>
}
    </div>

    @if (goldSyncDataLoading) {
<div class="loading-indicator">
      <i class="fa fa-spinner fa-spin gtw-red"></i>
    </div>
}

    @if (!goldSyncDataLoading && filteredDashboardRows.length > 0) {

      <div class="table-scroll-wrapper">
        <table class="gs-table">
          <thead>
            <tr>
              <th>Object Name</th>
              <th>Source Details</th>
              <th>Group Type</th>
              <th>Source Type</th>
              <th>Last Refreshed By</th>
              <th class="text-center">Last Refreshed Date</th>
              <th>
                <span class="cron-header inline-block">Scheduled (Cron)</span>
                <i
                  class="fa fa-question-circle cron-help-btn"
                  ap-tooltip [appendAfterTarget]="true" tooltipContent="What is a cron expression?"
                  direction="top"
                  (click)="onCronHelpBtnClick()"
                ></i>
              </th>
              <th class="gs-action-th">
                <div class="gs-action-th-inner">
                  <span class="gs-action-th-label">Actions</span>
                  <div class="actions-container actions-header-tools">
                  <label
                    class="chk-box-container mb-0"
                    ap-tooltip [appendAfterTarget]="true" tooltipContent="Select all active jobs for batch sync"
                    direction="top"
                  >
                    <input type="checkbox" (click)="toggleSelection($event)" />
                    <span
                      class="checkmark gs-header-checkmark"
                      [class.partial-selection]="partialSelection"
                      [class.full-selection]="fullSelection"
                    ></span>
                  </label>
                  <span class="gs-header-refresh-wrap" ap-tooltip [appendAfterTarget]="true" [tooltipContent]="batchSyncTooltip" direction="top">
                    <i
                      class="fa fa-refresh gs-refresh gs-header-refresh"
                      [class.disabled]="disableSyncAll"
                      (click)="syncSelected()"
                    ></i>
                  </span>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of paginatedDashboardRows; track $index) {
<tr>
              <td
                class="text-left cell-hoverable"
                ap-tooltip [appendAfterTarget]="true" tooltipContent="Click to see object counts"
                direction="top"
                (click)="onTableNameClick(row.dest_tbl_name)"
              >
                {{ row.dest_tbl_name }}
              </td>
              <td class="api-data-cell">
                <div class="api-data">
                  {{ getRowSourceDetailsDisplay(row) }}
                  @if (row.showMoreNLess) {
<span class="text-link" (click)="showHide(row)">{{
                    row.showTruncatedSrcQuery ? 'more' : 'less'
                  }}</span>
}
                </div>
              </td>
              <td>{{ row.grp_type }}</td>
              <td class="src-type-cell">
                <select
                  class="form-control src-type-dropdown"
                  [(ngModel)]="row.selectedSrcType"
                  (ngModelChange)="srcTypeChanged(row)"
                >
                  @for (st of srcTypeMappings; track $index) {
<option [ngValue]="st">{{ st.detail }}</option>
}
                </select>
              </td>
              <td>{{ row.updated_by_name }}</td>
              <td class="text-center">{{ row.last_run_dt }}</td>
              <td class="text-center cron-readable">{{ row.readableCron || '-' }}</td>
              <td class="action-column-cell">
                <div class="body-actions-container actions-container">
                  <label
                    class="chk-box-container mb-0"
                    [class.opa-0]="row.noSrcQuery || !row.jobStatusFlag"
                    ap-tooltip [appendAfterTarget]="true" tooltipContent="Include in batch sync"
                    direction="top"
                  >
                    <input type="checkbox" [(ngModel)]="row.selected" (change)="checkSelection()" />
                    <span class="checkmark gs-checkmark"></span>
                  </label>
                  <i
                    class="fa fa-refresh gs-refresh"
                    [class.disabled]="row.noSrcQuery || !row.jobStatusFlag"
                    ap-tooltip [appendAfterTarget]="true" tooltipContent="Sync this job"
                    direction="top"
                    (click)="sync(row)"
                  ></i>
                  <i
                    class="fa fa-pencil gs-edit"
                    ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit job details"
                    direction="top"
                    (click)="openEditModal(row)"
                  ></i>
                </div>
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>

      <div class="pagination-bar">
        <div class="pagination-controls">
          <button class="pagination-btn" [disabled]="dashboardCurrentPage <= 1" (click)="goToDashboardPage(1)">&laquo;</button>
          <button class="pagination-btn" [disabled]="dashboardCurrentPage <= 1" (click)="goToDashboardPage(dashboardCurrentPage - 1)">
            &lsaquo;
          </button>
          <span class="pagination-info">{{ dashboardCurrentPage }} of {{ dashboardTotalPages }}</span>
          <button
            class="pagination-btn"
            [disabled]="dashboardCurrentPage >= dashboardTotalPages"
            (click)="goToDashboardPage(dashboardCurrentPage + 1)"
          >
            &rsaquo;
          </button>
          <button
            class="pagination-btn"
            [disabled]="dashboardCurrentPage >= dashboardTotalPages"
            (click)="goToDashboardPage(dashboardTotalPages)"
          >
            &raquo;
          </button>
        </div>
        <select class="page-size-select" [ngModel]="dashboardPageSize" (ngModelChange)="onDashboardPageSizeChange($event)">
          @for (o of dashboardPageSizeOptions; track $index) {
<option [ngValue]="o">{{ o }} / Page</option>
}
        </select>
        <span class="pagination-info-text">{{ dashboardPaginationInfoText }}</span>
      </div>
    
}

    @if (!goldSyncDataLoading && goldSyncData.length > 0 && filteredDashboardRows.length === 0) {
<div class="noSettings">
      No matching jobs found.
    </div>
}
    @if (!goldSyncDataLoading && goldSyncData.length === 0) {
<div class="noSettings">
      No Gold Sync data to display.
    </div>
}
  </div>
}

  <!-- Tab 1: Log History -->
  @if (tabIndex === 1) {
<div class="log-hist">
    <div class="searchRow log-hist-toolbar">
      <div class="toolbar-left log-hist-page-length">
        <label>
          Show
          <select class="page-size-select" [(ngModel)]="logPageSize" (ngModelChange)="onLogPageLengthSelected()">
            @for (o of logPageLengthOptions; track $index) {
<option [ngValue]="o">{{ o }}</option>
}
          </select>
          entries
        </label>
      </div>
      <div class="toolbar-right">
        <div class="searchDiv log-hist-search-wrap">
          <label class="log-hist-search-label">
            Search:
            <span class="searchBlock">
              <input type="text" class="contentSearch" [(ngModel)]="logTableSearchTerm" />
            </span>
          </label>
          <i class="fa fa-search searchIcons"></i>
        </div>
      </div>
    </div>

    @if (logHistoryLoading) {
<div class="loading-indicator">
      <i class="fa fa-spinner fa-spin gtw-red"></i>
      <span>Loading...</span>
    </div>
}

    @if (!logHistoryLoading) {
<div class="log-hist-table-area">
      <table class="gs-table">
        <thead>
          <tr>
            <th class="gs-filter-th">
              <div class="gs-th-label-row">
                <span>Job Name</span>
                <button
                  type="button"
                  class="gs-filter-trigger"
                  [class.gs-filter-trigger--active]="logJobIdList.length > 0"
                  (click)="openJobNameFilter($event)"
                  title="Filter by job name"
                >
                  <i class="fa fa-filter"></i>
                </button>
              </div>
              @if (showJobNameFilter) {
<div
                class="log-hist-filter-panel log-hist-filter-panel--job"
               
                (mousedown)="onFilterPanelMouseDown($event)"
                (click)="$event.stopPropagation()"
              >
                <div class="log-hist-filter-panel__header">Filter by Job Name</div>
                <div class="filter-search-container">
                  <input
                    class="filter-search form-control input-sm"
                    type="text"
                    placeholder="Search job name..."
                    [(ngModel)]="jobNameSearchTerm"
                  />
                </div>
                <div class="filter-selection-container">
                  <label class="filter-option filter-option--select-all">
                    <input type="checkbox" [(ngModel)]="jobNamesSelectAll" (click)="jobNamesFilterSelectAll($event)" />
                    Select All
                  </label>
                  @for (job of goldSyncJobs; track $index) {
<label class="filter-option" [hidden]="!searchJobName(job)">
                    <input type="checkbox" [(ngModel)]="job.selected" />
                    <span class="filter-option-text">{{ job.job_name }}</span>
                  </label>
}
                </div>
                <div class="filter-footer">
                  <button type="button" class="btn btn-default btn-sm" (click)="showJobNameFilter = false">Cancel</button>
                  <button type="button" class="btn btn-primary btn-sm" (click)="filterByJobName()">Apply</button>
                </div>
              </div>
}
            </th>
            <th class="gs-filter-th">
              <div class="gs-th-label-row">
                <span>Tax Year</span>
                <button
                  type="button"
                  class="gs-filter-trigger"
                  [class.gs-filter-trigger--active]="logTaxYearList.length > 0"
                  (click)="openTaxYearFilter($event)"
                  title="Filter by tax year"
                >
                  <i class="fa fa-filter"></i>
                </button>
              </div>
              @if (showTaxYearFilter) {
<div
                class="log-hist-filter-panel log-hist-filter-panel--tax"
               
                (mousedown)="onFilterPanelMouseDown($event)"
                (click)="$event.stopPropagation()"
              >
                <div class="log-hist-filter-panel__header">Filter by Tax Year</div>
                <div class="filter-search-container">
                  <input
                    class="filter-search form-control input-sm"
                    type="text"
                    placeholder="Search tax year..."
                    [(ngModel)]="taxYearSearchTerm"
                  />
                </div>
                <div class="filter-selection-container">
                  <label class="filter-option filter-option--select-all">
                    <input type="checkbox" [(ngModel)]="taxYearSelectAll" (click)="taxYearFilterSelectAll($event)" />
                    Select All
                  </label>
                  @for (year of goldSyncTaxYears; track $index) {
<label class="filter-option" [hidden]="!searchTaxYear(year)">
                    <input type="checkbox" [(ngModel)]="year.selected" />
                    <span class="filter-option-text">{{ year.tax_year }}</span>
                  </label>
}
                </div>
                <div class="filter-footer">
                  <button type="button" class="btn btn-default btn-sm" (click)="showTaxYearFilter = false">Cancel</button>
                  <button type="button" class="btn btn-primary btn-sm" (click)="filterByTaxYear()">Apply</button>
                </div>
              </div>
}
            </th>
            <th>Group Object Key</th>
            <th>Success Indicator</th>
            <th>Refreshed By</th>
            <th>Refreshed Date</th>
            <th>Sync Count</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          @for (row of filteredLogHistoryRows; track trackLogHistoryRow($index, row)) {
<tr>
            <td>{{ row['job_name'] }}</td>
            <td>{{ row['tax_year'] }}</td>
            <td>{{ row['group_obj_key'] }}</td>
            <td>{{ row['success_ind'] }}</td>
            <td>{{ row['refresh_by'] }}</td>
            <td>{{ row['refresh_dt'] }}</td>
            <td>{{ row['sync_count'] }}</td>
            <td>{{ row['description'] }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
}

    @if (!logHistoryLoading) {
<div class="log-hist-pagination">
      <ul class="pagination">
        <li class="paginate-button previous" [class.disabled]="logPage === 1">
          <a (click)="flipLogPage(-1)">Previous</a>
        </li>
        <li class="paginate-button no-hover">
          <span class="paginate-page-number">{{ logPage }}</span>
        </li>
        <li class="paginate-button next">
          <a (click)="flipLogPage(1)">Next</a>
        </li>
      </ul>
    </div>
}
  </div>
}
</div>

<!-- Edit job modal (pattern from cache-control) -->
@if (showEditModal) {
<div class="admin-modal-overlay" (click)="requestCloseEditModal()">
  <div class="admin-modal-dialog gs-edit-modal" (click)="$event.stopPropagation()">
    <div class="admin-modal">
      <div class="modal-header">
        <h3 class="modal-title">{{ newObject ? 'New Gold Sync Job' : 'Edit Gold Sync Job' }}</h3>
        <div class="header-actions">
          <i class="fa fa-times" style="cursor: pointer" (click)="requestCloseEditModal()"></i>
        </div>
      </div>

      @if (jobToEdit) {
<div class="modal-body">
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Object Name*</div>
          @if (!newObject) {
<div class="col-sm-9">
            <select class="form-control font-size-override" [ngModel]="jobToEdit" (ngModelChange)="onJobToEditSelected($event)">
              @for (data of goldSyncDataCopy; track $index) {
<option [ngValue]="data">{{ data.dest_tbl_name }}</option>
}
            </select>
          </div>
}
          @if (newObject) {
<div class="col-sm-9">
            <input
              class="form-control font-size-override job-name-input"
              [(ngModel)]="jobToEdit.dest_tbl_name"
              (ngModelChange)="doValidate()"
            />
          </div>
}
        </div>
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Source Details</div>
          <div class="col-sm-9">
            <textarea
              class="form-control font-size-override job-details-txtarea"
              rows="5"
              [(ngModel)]="jobToEdit.src_details"
              (ngModelChange)="doValidate()"
            ></textarea>
          </div>
        </div>
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Source Type*</div>
          <div class="col-sm-9">
            <select class="form-control font-size-override" [(ngModel)]="jobToEdit.selectedSrcType" (ngModelChange)="changeSrcType()">
              @for (st of srcTypeMappings; track $index) {
<option [ngValue]="st">{{ st.detail }}</option>
}
            </select>
          </div>
        </div>
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">
            Scheduled (Cron)*
            <i class="fa fa-question-circle cron-help-btn" title="What's a cron expression?" (click)="onCronHelpBtnClick()"></i>
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              maxlength="20"
              class="form-control inline-block font-size-override cron-editor"
              [class.cron-input-shake]="jobToEdit.doShake"
              [(ngModel)]="jobToEdit.cronDisplay"
              (keyup)="checkCron(jobToEdit, false); doValidate()"
              (focus)="onCronEditorFocused(jobToEdit)"
              (blur)="onCronEditorBlur(jobToEdit)"
            />
            <i
              class="fa fa-info-circle cron-info"
              [title]="jobToEdit.readableCron"
              [style.color]="jobToEdit.invalidCron ? '#ea1000' : '#505050'"
            ></i>
          </div>
        </div>
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Status*</div>
          <div class="col-sm-9">
            <label class="switch">
              <input type="checkbox" [(ngModel)]="jobToEdit.jobStatusFlag" />
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Group Type*</div>
          <div class="col-sm-9">
            <select class="form-control font-size-override" [(ngModel)]="jobToEdit.selectedGrpType" (ngModelChange)="doValidate()">
              @for (gt of grpTypeMappings; track $index) {
<option [value]="gt">{{ gt }}</option>
}
            </select>
          </div>
        </div>
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Source Object Name</div>
          <div class="col-sm-9">
            <input class="form-control font-size-override src-obj-name-input" [(ngModel)]="jobToEdit.src_tbl_name" />
          </div>
        </div>
        <div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Job Description</div>
          <div class="col-sm-9">
            <textarea class="form-control font-size-override" maxlength="500" rows="2" [(ngModel)]="jobToEdit.job_desc"></textarea>
          </div>
        </div>
        @if (jobToEdit.selectedSrcType?.fromData === 'DS') {
<div class="row edit-card-body-row">
          <div class="col-sm-3 form-label">Data Source*</div>
          <div class="col-sm-9">
            <select class="form-control font-size-override" [(ngModel)]="jobToEdit.src_ds_name" (ngModelChange)="doValidate()">
              @for (ds of dsNames; track $index) {
<option [value]="ds">{{ ds }}</option>
}
            </select>
          </div>
        </div>
}
      </div>
}

      <div class="modal-footer gs-edit-modal-footer">
        <button type="button" class="btn btn-info btn-sm" (click)="requestCloseEditModal()">Cancel</button>
        @if (!newObject) {
        <button type="button" class="btn btn-warning btn-sm" (click)="requestCreateNewJob()">
          New job
        </button>
        }
        <button
          type="button"
          class="btn btn-primary btn-sm"
          [disabled]="invalidForm || savingEdit || !jobToEdit"
          (click)="saveEdit()"
        >
          {{ newObject ? 'Create Job' : 'Save' }}
          @if (savingEdit) {
<i class="fa fa-spinner fa-spin"></i>
}
        </button>
      </div>
    </div>
  </div>
</div>
}

@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()"
  ></gtw-confirmation-modal>
</div>
}
